<template>
  <tr class="customer-item" v-if="user" @click="showModal = true" style="cursor: pointer">
    <td>
      <v-avatar size="30">
        <img
          v-if="user.profile_pic"
          @error="onFailLoad"
          :src="user.profile_pic"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
        />
        <img
          v-else
          :src="'/static/img/assets/livechat/profile.png'"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
        />
      </v-avatar>
    </td>
    <td
      style="min-width: 300px"
      :title="(user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : '') "
    >
      <div
        style="display: inline-block;vertical-align: top;margin-top: 5px;"
      >{{(user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : '') | truncate(35)}}</div>
    </td>
    <td>{{user.uu_name}}</td>
    <td>{{user.uu_areaname}}</td>
    <td>{{user.uu_dma}}</td>

    <td>
      <v-btn outline fab small class="extra-small" color="primary">
        <i class="fas fa-align-left"></i>
      </v-btn>

      <v-dialog v-model="showModal" width="800">
        <v-card>
          <uu-customer-detail v-if="showModal" v-model="user">
            <div slot="header" class="text-xs-right">
              <v-btn flat fab small class="extra-small" @click="showModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </uu-customer-detail>

          <v-card-text class="text-xs-center">
            <v-btn outline color="grey" @click="showModal = false">{{$t('cancel')}}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ModalDialog from '@/components/elements/ModalDialog'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'
import Multiselect from 'vue-multiselect'
import UuCustomerDetail from './UuCustomerDetail'
export default {
  props: ['value'],
  data: function() {
    return {
      user: undefined,
      showModal: false,
      showAllIntent: false,
      isEditTag: false,
      isEditAreacode: false,
      isEditLocation: false,
      usertag: '',
      uuAreaNameOption: [
        {
          value: 1,
          label: 'ประปาบางปะกง'
        },
        {
          value: 2,
          label: 'ประปาฉะเชิงเทรา'
        },
        {
          value: 3,
          label: 'ประปาบ่อวิน'
        },
        {
          value: 4,
          label: 'ประปาหนองขาม'
        },
        {
          value: 5,
          label: 'ประปาสัตหีบ'
        },
        {
          value: 6,
          label: 'ประปาระยอง'
        },
        {
          value: 7,
          label: 'ประปานครสวรรค์'
        },
        {
          value: 8,
          label: 'ประปาหัวรอ'
        },
        {
          value: 0,
          label: 'นอกพื้นที่บริการ'
        }
      ],
      uuAreaName: null
    }
  },
  components: {
    ModalDialog,
    CustomerItemValue,
    EditCustomerValue,
    specialtext,
    Tags,
    Multiselect,
    UuCustomerDetail
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntent: function() {
      var vm = this
      return vm.user.intentlist.sort(function(a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function() {
      var vm = this
      return config.locale.find(function(locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function() {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  mounted: function() {
    var vm = this
    vm.user = vm.value
    vm.cached_tag = vm.user.tags
  },
  methods: {
    onFailLoad: function() {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return moment(date).format(format)
    }
  },
  watch: {
    value: function() {
      this.user = this.value
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/UuCustomerItem.vue